import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { customerApi } from "@/lib/api";
import SEO from "@/components/SEO";
import Logo from "@/components/Logo";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, error: "" });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, error: "Ungültiger Bestätigungslink." });
      return;
    }
    customerApi
      .get(`/customer/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => setState({ loading: false, ok: true, error: "" }))
      .catch((e) => setState({ loading: false, ok: false, error: e.response?.data?.detail || "Bestätigung fehlgeschlagen." }));
  }, [token]);

  return (
    <div className="on-dark violet-canvas flex-1 w-full flex items-center justify-center px-5 py-24">
      <SEO title="E-Mail bestätigen" />
      <div className="w-full max-w-md text-center">
        <Logo variant="butterfly" className="h-14 w-auto mx-auto mb-6" />
        <div className="bg-[#FFF9F2] rounded-md p-8" data-testid="verify-result">
          {state.loading ? (
            <p className="text-[#6E5A82]">Bestätige…</p>
          ) : state.ok ? (
            <>
              <h1 className="font-serif text-3xl mb-3">E-Mail bestätigt ✓</h1>
              <p className="text-[#3A1E55]">Dein Konto ist jetzt aktiv. Du kannst dich anmelden.</p>
              <Link to="/anmelden" data-testid="verify-goto-login" className="mt-6 inline-block bg-[#F4C542] text-[#32104F] rounded-md px-8 h-12 leading-[3rem] font-medium">
                Zur Anmeldung
              </Link>
            </>
          ) : (
            <>
              <h1 className="font-serif text-3xl mb-3">Bestätigung fehlgeschlagen</h1>
              <p className="text-[#3A1E55]">{state.error}</p>
              <Link to="/registrieren" className="mt-6 inline-block text-[#632A8E] underline">Erneut registrieren</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
